import { Tooltip, TooltipContent, TooltipTrigger } from "@repo/ui";
import { Zap } from "lucide-react";

export const ClientSideLabel = ({ label }: { label: React.ReactNode }) => (
	<span className="flex items-center gap-1">
		{label}
		<Tooltip>
			<TooltipTrigger asChild>
				<span role="img" tabIndex={0} aria-label="Client-side filter">
					<Zap aria-hidden className="h-3 w-3 fill-yellow-400 text-yellow-400" />
				</span>
			</TooltipTrigger>
			<TooltipContent>
				<p>Fast update, no need to click execute</p>
			</TooltipContent>
		</Tooltip>
	</span>
);
